import { Button, Icon, Input, message, Modal } from 'antd'
import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { api } from '../../../../../../../../../services'
import actions from '../../../../../../../../../store/actions'
import nanoid from 'nanoid'
import { useTranslation } from 'react-i18next'

const WorldScenario = ({
  onCancel,
  extractedText,
  lessonTitle,
  pageStructureData,
  lessonUpdate,
  pages,
  currentPage,
  backgroundImageId = '',
  backgroundImageLink = '',
  backgroundImageOpacity = 0,
  backgroundColor = '',
  language
}) => {
  const [isGenerating, setIsGenerating] = useState(false)
  const [responseId, setResponseId] = useState('')
  const [userInstruction, setUserInstruction] = useState('')
  const [text, setText] = useState('')
  const { handleLessonInput } = actions.lessonBuilder

  const dispatch = useDispatch()

  const { t } = useTranslation()

  useEffect(() => {
    setText(extractedText)
  }, [extractedText])

  const startGeneration = () => {
    setIsGenerating(true)
    try {
      const currentPageData = pageStructureData[currentPage]
      let plainText = ''

      if (currentPageData && currentPageData.data) {
        const HeadingElement = currentPageData.data.find(
          item => item.type === 'TEXT' && item.display === 'HEADING'
        )
        plainText = HeadingElement?.params?.content?.replace(
          /<\/?[^>]+(>|$)/g,
          ''
        )
      }

      api.courses
        .generateWorldScenario({
          content: text,
          topic: lessonTitle || 'Real World Scenaio',
          subtopic: plainText,
          response_id: responseId,
          user_instruction: userInstruction,
          language
        })
        .then(res => {
          if (res?.data) {
            setResponseId(res.data?.response_id)
            setText(res.data?.scenario)
          }
        })
        .catch(err => {
          console.log(err)
        })
        .finally(() => {
          setIsGenerating(false)
        })
    } catch (error) {
      console.error('Error preparing generation request:', error)
      setIsGenerating(false)
    }
  }
  const addPage = () => {
    const currentPageData = pageStructureData[currentPage - 1]
    const logoItem = currentPageData.data.find(
      item => item.type === 'IMAGE' && item.display === 'LOGO'
    )
    const backgroundItem = backgroundImageId
      ? {
          uid: nanoid(8),
          type: 'BACKGROUND_IMAGE',
          params: {
            content: backgroundImageLink,
            content_id: backgroundImageId,
            opacity: backgroundImageOpacity
          }
        }
      : {
          uid: nanoid(8),
          type: 'BACKGROUND_COLOR',
          display: 'BACKGROUND_COLOR',
          params: {
            content: backgroundColor,
            content_id: null,
            opacity: 1
          }
        }

    const newPageData = {
      size: { width: 1024, height: 768 },
      orientation: 'landscape',
      data: [
        {
          uid: nanoid(8),
          type: 'TEXT',
          display: 'HEADING',
          params: {
            content: `<h1 class=\"ql-align-center\"><strong style=\"font-size: 36px;\">${t(
              'v4:real_world_scenario',
              { lng: language }
            )}</strong></h1>`,
            x: 57,
            y: 50,
            width: 900,
            height: 67,
            media_format: 'TEXT'
          }
        },
        {
          uid: nanoid(8),
          type: 'TEXT',
          display: 'CONTENT',
          params: {
            content: text,
            x: 57,
            y: 146,
            width: 900,
            height: 353
          }
        },
        backgroundItem,
        logoItem
      ].filter(Boolean)
    }

    const newPage = {
      data: [],
      orientation: 'portrait',
      size: { width: 1024, height: 768 }
    }

    const newData = [...pageStructureData]
    const newPages = [...pages]

    newData.push(newPageData)
    newPages.push(newPage)

    dispatch(handleLessonInput('pages_landscape', newData))
    dispatch(handleLessonInput('pages', newPages))
    dispatch(handleLessonInput('currentPage', currentPage))
    lessonUpdate({ pages_landScape: newData, pages: newPages })

    message.success('Real World Scenario added at the end of the lesson.')
    onCancel()
  }
  return (
    <Modal
      visible
      title={t('v4:real_world_scenario')}
      footer={null}
      onCancel={onCancel}
      width={700}
      bodyStyle={{ padding: '24px 32px' }}
      centered
    >
      <div style={{ marginBottom: '24px' }}>
        <span
          style={{
            display: 'block',
            marginBottom: '8px',
            fontWeight: 600,
            color: '#262626'
          }}
        >
          {t('v4:add_optional_instructions')}
        </span>
        <Input.TextArea
          placeholder={t('v4:add_optional_instructions')}
          autoSize={{ minRows: 3, maxRows: 6 }}
          value={userInstruction}
          onChange={e => setUserInstruction(e.target.value)}
          style={{
            borderRadius: '4px',
            borderColor: '#d9d9d9',
            padding: '8px 12px'
          }}
        />
      </div>

      {responseId ? (
        <div style={{ animation: 'fadeIn 0.3s ease' }}>
          <span
            style={{
              display: 'block',
              marginBottom: '8px',
              fontWeight: 600,
              color: '#262626'
            }}
          >
            {t('v5:generated_real_world_scenario') || 'Generated Scenario'}
          </span>
          <Input.TextArea
            autoSize={{ minRows: 8, maxRows: 20 }}
            value={text}
            onChange={e => setText(e.target.value)}
            style={{
              marginBottom: '24px',
              borderRadius: '4px',
              borderColor: '#d9d9d9',
              padding: '8px 12px'
            }}
          />
          <div
            style={{
              display: 'flex',
              justifyContent: 'flex-end',
              gap: '12px',
              marginTop: '24px',
              borderTop: '1px solid #f0f0f0',
              paddingTop: '16px'
            }}
          >
            <Button
              onClick={() => startGeneration()}
              loading={isGenerating}
              style={{ minWidth: '120px' }}
            >
              {t('v4:regenerate_with_instructions')}
              {!isGenerating && (
                <Icon type="reload" style={{ marginLeft: 6 }} />
              )}
            </Button>
            <Button
              type="primary"
              icon="check"
              onClick={() => addPage()}
              style={{ minWidth: '120px' }}
            >
              {t('v4:add_real_world_scenario')}
            </Button>
          </div>
        </div>
      ) : (
        <div
          style={{
            padding: '32px',
            backgroundColor: '#fafafa',
            borderRadius: '4px',
            border: '1px solid #e8e8e8',
            textAlign: 'center',
            marginTop: '8px'
          }}
        >
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              marginBottom: '24px'
            }}
          >
            <div
              style={{
                width: '48px',
                height: '48px',
                borderRadius: '50%',
                backgroundColor: '#e6f7ff',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                marginBottom: '16px',
                color: '#1890ff'
              }}
            >
              <Icon type="bulb" style={{ fontSize: '24px' }} />
            </div>
            <h4
              style={{
                margin: '0 0 8px 0',
                color: '#262626',
                fontWeight: 600,
                fontSize: '16px'
              }}
            >
              {t('v4:ready_to_enerate_your_real_world_scenario')}
            </h4>
            <p style={{ margin: '0 0 24px 0', color: '#595959' }}>
              {t(
                'v4:click_generate_real_world_scenario_to_create_a_realistic_scenario'
              )}
            </p>
            <div
              style={{
                textAlign: 'left',
                backgroundColor: '#fff',
                padding: '16px 24px',
                borderRadius: '4px',
                border: '1px solid #f0f0f0',
                marginBottom: '24px',
                width: '100%'
              }}
            >
              {[
                'v4:the_ai_will_analyze_your_lesson_topic_and_content',
                'v4:generate_a_practical_real_world_scenario',
                'v4:you_can_then_edit_and_customize_the_result',
                'v4:add_it_as_a_new_page_to_your_lesson'
              ].map((key, index) => (
                <div
                  key={index}
                  style={{
                    display: 'flex',
                    marginBottom: '8px',
                    color: '#595959'
                  }}
                >
                  <Icon
                    type="check-circle"
                    theme="filled"
                    style={{
                      color: '#52c41a',
                      marginRight: '8px',
                      marginTop: '4px'
                    }}
                  />
                  <span>{t(key)}</span>
                </div>
              ))}
            </div>
          </div>
          <Button
            type="primary"
            size="large"
            onClick={() => startGeneration()}
            loading={isGenerating}
            style={{
              paddingLeft: '32px',
              paddingRight: '32px',
              height: '40px',
              fontSize: '14px'
            }}
          >
            {t('v4:generate_real_world_scenario')}
          </Button>
        </div>
      )}
    </Modal>
  )
}

export default WorldScenario
